module.exports = __webpack_public_path__ + "static/media/like-after.83ff8df9.png";